<template>
  <div class="status-main" :style="[ isComponent && { padding: '5px' } ]">
    <DocStatusUpdate :showPopup.sync="updatePopup" defaultCategory="status" :jobno="jobno" :title="`Update Status for Job # ${jobno}`"
      @statusUpdated="statusUpdated" :statusList.sync="statusList" :editDetails.sync="editDetails" />
    <div class="top-section" :style="{ padding : isComponent ? '0' : '5px', margin: '0 0 5px 0' }">
      <DropdownSearch
        placeholder="Search Job, Consignment, or Container No."
        primaryKey="Job_no"
        :secondaryFields="[
          { key: 'ConsignmentNo', label: 'Consignment' },
          { key: 'ContainerNo', label: 'Container' },
          { key: 'SystemDesc', label: 'System' }
        ]"
        :searchFunction="getJobNoList"
        :selectedObject.sync="selectedJobNo"
        style="margin-bottom: 10px"
        :search="jobno"
        :minimumSearchLength="2"
        :maximumResults="50"
        @selected="getStatusTask"
        v-if="!isComponent"
      />
        <button :disabled="!jobno" @click="updatePopup = true">Add Status</button>
        <button :disabled="!jobno" @click="editStatus">Edit Status</button>
        <button :disabled="!jobno" @click="deleteStatus">Delete Status</button>

    </div>
    <div class="top-section" :style="{ padding : isComponent ? '0' : '5px', margin: '0 0 5px 0' }">
      <BigLegends :legends="legends" @legendToggle="legendToggle" />
    </div>
    <div class="table-section" :style="{ padding : isComponent ? '0' : '5px', height: isComponent ? '100%' : 'calc(100% - 90px)', 'min-height': 0 }">
      <TableBox :title="jobno ? `${jobno} Status TAS` : 'Status TAS'" :tableData="showData" :loading="loading" :selectedRow.sync="selectedStatus" :additionalIconsIndex="[ 0 ]"
        :dataType="{ 'Last Update': 'datetime', 'Finish Time': 'datetime' }" />
    </div>

    <PopupV2 :show="showDeletePopup" @buttonClicked="deleteButtonClicked" :title="popupTitle" :content="popupContent" :type="popupType"
      :buttons="popupButtons">
      <div v-if="!popupContent && selectedStatus.length > 0" class="delete-popup">
        <div>
          Please confirm to delete status {{ selectedStatus[0]['Status'].trim() }} for Job # {{ jobno.trim() }}?<br>
          Deleted status cannot be re-activated. <br><br>
          To delete, please enter your reason below:
        </div>
        <Input :isRequired="true" placeholder="Reason" :inputValue.sync="deleteReason" :errorMessage.sync="deleteReasonError" />
        <CheckBox :title="`Re-create pending status after deletion`" :isChecked.sync="generatePendingStatus" />
      </div>
    </PopupV2>
    
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data: function() {
    return {
      loading: false,

      legends: [],

      jobno: '',
      statusTaskList: [],
      showData: [],
      hideRow: [],
      documentsList: [],
      statusList: [],
      updatePopup: false,

      selectedStatus: [],
      editDetails: null,

      showDeletePopup: false,
      popupType: '',
      popupContent: '',
      popupButtons: [],
      popupTitle: '',
      deleteButtons: [
        { text: 'Delete', color: 'red', textColor: 'white' },
        { text: 'Cancel' },
      ],
      deleteReason: '',
      deleteReasonError: '',
      generatePendingStatus: false,
      selectedJobNo: null
    }
  },
  props: {
    isComponent: { type: Boolean, default: false }, // Set to true if this page is used in another page as a component
    statusData: { type: Array, default: function() { return [] } }, // The data of the status
    statusDocuments: { type: Array, default: function() { return [] } }, // The documents for the data
    statusJobNo: { type: String, default: function() { return '' } }, // The job no for the status
  },
  computed: {
  },
  methods: {
    systemFieldFormatter(systemField){
      switch(systemField.toUpperCase()){
        case 'HMS':
          return 'Haulage'
        case 'FMS':
        case 'FTZ':
        case 'FRE':
          return 'Freight Forwarding'
        case 'WMS':
          return 'Warehouse'
        case 'TMS':
          return 'Trucking'
        case 'YMS':
          return 'Yard/Depot'
        default:
          return systemField
      }
    },
    getJobNoList: function(search) {
      return this.$apiCallV2('/DocStatusUpdate/GetStatusTrackingJobNo', {
        search: search.trim(),
        maxResults: 50,
      }).then((response) => {
        const addSystemDescription = (items) => items.map((item) => ({
          ...item,
          SystemDesc: this.systemFieldFormatter(item.System),
        }));

        const responseItems = Array.isArray(response)
          ? response
          : response && Array.isArray(response.items)
            ? response.items
            : null;

        if (responseItems === null) {
          return Promise.reject(new Error('Invalid job search response'));
        }

        if (responseItems.length === 1 && String(responseItems[0].Results) === '1' && responseItems[0].ErrMsg) {
          return Promise.reject(new Error(responseItems[0].ErrMsg));
        }

        if (Array.isArray(response)) {
          return addSystemDescription(responseItems);
        }
        return { ...response, items: addSystemDescription(responseItems) };
      });
    },
    getStatusTask: async function(jobNoInput) {
      const jobNo = typeof jobNoInput === 'string' ? jobNoInput : jobNoInput['Job_no'];
      this.jobno = jobNo.trim();

      this.$fullscreenLoading('Getting Status');
      let statusTask = await this.$apiCallV2(`/FreightForwarding/GetStatusTaskList?jobno=${jobNo.trim()}`);
      this.$fullscreenLoading();
      statusTask = statusTask.filter(s => s['#'] != '0');
      this.statusTaskList = this.appendStatusIcon(statusTask);

      this.filterShowStatus();

      if (this.isComponent) {
        this.$emit('update:statusData', this.statusTaskList);
      }
    },
    getDocuments: async function() {
      this.$fullscreenLoading('Getting Documents');
      this.documentsList = await this.$apiCallV2(`/FreightForwarding/GetJobDocuments?jobno=${this.jobno.trim()}`);
      this.$fullscreenLoading();

      if (this.isComponent) {
        this.$emit('update:statusDocuments', this.documentsList);
      }
    },
    statusUpdated: async function() {
      this.statusTaskList = [];
      await this.getStatusTask(this.jobno);
      await this.getDocuments();
    },
    editStatus: function() {
      this.popupType = 'error';
      this.popupTitle = 'Editing Status';
      
      if (this.selectedStatus.length > 0) {
        if (this.selectedStatus[0]['Progress'] == 'Cancelled') {
          this.showDeletePopup = true;
          this.popupContent = 'Cancelled status cannot be edited.';
          this.popupButtons = [];
          return;
        }

        this.updatePopup = true;
        this.editDetails = this.selectedStatus[0];

        let hasAtt = this.documentsList.find(d => d['DocumentGUID'] == this.editDetails['TxnGUID']);
        if (hasAtt) {
          this.editDetails['attachment'] = hasAtt['AttImageName'];
          this.editDetails['docCode'] = hasAtt['Doc Code'];
          this.editDetails['docType'] = hasAtt['Type'];
          this.editDetails['sets'] = hasAtt['Sets'];
          this.editDetails['pages'] = hasAtt['Pages'];
          this.editDetails['refno'] = hasAtt['Reference No'];
        }
      } else {
        this.showDeletePopup = true;
        this.popupContent = 'Please select one status to edit!';
        this.popupButtons = [];
      }
    },
    deleteStatus: function () {
      this.showDeletePopup = true;
      this.popupTitle = 'Deleting Status';

      this.deleteReason = '';
      this.deleteReasonError = '';
      this.generatePendingStatus = false;

      if (this.selectedStatus.length > 0) {
        this.popupType = this.selectedStatus[0]['Progress'] == 'Cancelled' ? 'error' : 'warning';
        this.popupContent = this.selectedStatus[0]['Progress'] == 'Cancelled' ? 'This status is already cancelled': '';
        this.popupButtons = this.selectedStatus[0]['Progress'] == 'Cancelled' ? [] : this.deleteButtons;
      } else {
        this.popupType = 'error';
        this.popupContent = 'Please select one status to delete!';
        this.popupButtons = [];
      }
    },
    deleteButtonClicked: async function(e) {
      this.deleteReasonError = '';

      if (e == 'Delete') {
        if (!this.deleteReason) {
          this.deleteReasonError = 'Please enter your reason to delete';
          return;
        } else if (this.deleteReason.trim() === '') {
          this.deleteReasonError = 'Reason is required!';
        } else {
          this.popupType = 'loading';
          this.popupContent = 'Please wait . . .';
          this.popupButtons = null;
          this.$fullscreenLoading('Updating Task');
          let deleteStatus = await this.$apiCallV2('/DocStatusUpdate/UpdateStatusTask', {
            'jobno': this.selectedStatus[0]['Job #'].trim(),
            'seqno': this.selectedStatus[0]['#'],
            'status': this.selectedStatus[0]['Status'].trim(),
            'action': 'D',
            'newoption': this.generatePendingStatus ? 1 : 0,
            'reason': this.deleteReason
          });
          this.$fullscreenLoading();
          this.popupButtons = [];

          if (deleteStatus[0]['Results'] == 0) {
            this.popupType = 'success';
            this.popupContent = `Successfully deleted status ${this.selectedStatus[0]['Status'].trim()}!${deleteStatus[0]['New SeqNo'] ? `<br /><br />Sequence number for the newly generated status is ${deleteStatus[0]['New SeqNo']}` : ''}`;

            await this.statusUpdated();
          } else {
            this.popupType = 'error';

            if (deleteStatus[0]['ErrMsg']) {
              this.popupContent = deleteStatus[0]['ErrMsg'];
            } else {
              this.popupContent = 'Status not delete, there was an error occurred. Please try again';
            }
          }
        }
      } else {
        this.showDeletePopup = false;
      }
    },

    filterShowStatus: function() {
      // let hideItems = this.legends.filter(l => !l['show']).map(h => h['key']);
      // this.hideRow = { key: 'Progress', values: hideItems };
      if(this.$route.query['status']){
        this.statusTaskList = this.statusTaskList.filter(item => item.Status === this.$route.query['status']);
      }
      if (this.legends.length > 0) {
        let showItems = this.legends.filter(l => l['show']).map(h => h['key']);
        this.showData = [];
        this.$nextTick(() => {
          this.showData = this.statusTaskList.filter(s => showItems.find(i => s['Progress'].toUpperCase().includes(i.toUpperCase())));
        });
      } else {
        this.showData = this.statusTaskList;
      }
    },

    legendToggle: async function() {
      this.filterShowStatus();
    },

    appendStatusIcon: function(list) {
      let allStatus = list.sort((a, b) => { return (a['#'] < b['#']) ? 1 : -1 });
      let statusWithIcons = allStatus.map(s => {
        if (s['Progress'].toUpperCase().includes('COMPLETED')) {
          return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/StatusComplete.png' }, s);
        } else if (s['Progress'].toUpperCase().includes('DUE')) {
          return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/StatusDue.png' }, s);
        } else if (s['Progress'].toUpperCase().includes('DUE IN 2 DAYS')) {
          return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/StatusDueIn2Days.png' }, s);
        } else if (s['Progress'].toUpperCase().includes('PENDING')) {
          return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/StatusPending.png' }, s);
        }  else if (s['Progress'].toUpperCase().includes('CANCELLED')) {
          return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/StatusCancelled.png' }, s);
        } else {
          return Object.assign({ '': '' }, s);
        }
      });

      return statusWithIcons;
    },
  },
  watch:{
    statusData: function(val) {
      if (this.isComponent && val && val.length > 0) {
        this.statusTaskList = val.filter(s => s['#'] != '0');
        this.filterShowStatus();
      }
    },
    statusJobNo: function(val) {
      if (val) {
        this.jobno = val;
      }
    },
    statusDocuments: function(val) {
      if (this.isComponent) {
        this.documentsList = val;
        
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.jobno = to.query['jobno'] ? to.query['jobno'] : to.params['jobno'];
    if(!this.jobno){
      this.showData = [];
    }
    else{
      this.getStatusTask(this.jobno);
    }
    next();
  },
  async mounted() {
    this.jobno = this.$route.query['jobno'] ? this.$route.query['jobno'] : this.$route.params['jobno']; //can remove the route query jobno if confirm not used anymore since have params
    if(this.jobno){
      this.selectedJobNo = {
        Job_no: this.jobno
      };
    }
    this.$apiCallV2('/FreightForwarding/GetStatusTaskList?legend=1').then((r) => {
      let legend = r['Legend'];
      
      this.legends = Object.entries(legend).map(([k,v]) => {
        return { name: k, color: v, show: k != 'Cancelled', key: k }
      });

      if (this.isComponent || this.$route.query['status']) {
        this.filterShowStatus();
      }
      //   { name: 'Completed', color: 'green', textColor: 'white', show: true, key: 'Completed' },
      //   { name: 'Pending', color: 'yellow', textColor: 'black', show: true, key: 'Pending' },
      //   { name: 'Due', color: 'orange', textColor: 'black', show: true, key: 'Due' },
      //   { name: 'Cancelled', color: 'red', textColor: 'black', show: false, key: 'Cancelled' },
    });

    this.$fullscreenLoading();

    if (this.isComponent) {
      this.statusTaskList = this.statusData;
      this.jobno = this.statusJobNo;
      this.documentsList = this.statusDocuments;
    } else {
      if (this.jobno) {
        await this.getStatusTask(this.jobno);
        await this.getDocuments();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.status-main {
  padding: 10px 45px;
  // padding-top: 10px;
  padding-right:10px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;

  > .top-section, > .table-section {
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    width: 100%;
  }

  > .top-section {
    flex: 0 0 auto;
  }

  > .table-section {
    flex: 1 1 0;
    height: auto !important;
    min-height: 0;
    overflow: hidden;
  }

  > .top-section button {
    margin-right: 5px;
  }
}

.delete-popup {
  text-align: left;
  padding: 20px;
}
</style>
